
import {
  createComponent,
  reactive,
  computed,
  inject,
} from "@vue/composition-api";
import ResultStoreKey from "./result-store-key";
import { getLevelStr } from "@/lib/typeWell";
import { calcUps, calcUpm } from "@/lib/typing-utils";

type Props = {
  timeMs: number;
};

export default createComponent({
  props: {
    timeMs: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const resultStore = inject(ResultStoreKey);
    if (!resultStore) {
      throw new Error(`${ResultStoreKey} is not provided`);
    }

    // TODO: romanLengthがマジックナンバーになっている
    const romanLength = 400;

    const state = reactive({
      // 結果
      timeMs: computed(() => resultStore.timeMs),
      time: computed((): string => (state.timeMs / 1000).toFixed(3)),
      level: computed((): string => getLevelStr(state.timeMs)),
      missCount: computed((): number => resultStore.missCount),
      tpm: computed((): number => calcUpm(romanLength, state.timeMs)),
      tps: computed((): number => calcUps(romanLength, state.timeMs)),
      tpmStr: computed((): string => state.tpm.toFixed(2)),
      tpsStr: computed((): string => state.tps.toFixed(3)),
      rate: computed(
        (): number => romanLength / (romanLength + state.missCount)
      ),
      rateStr: computed((): string => (state.rate * 100).toFixed(2)),
      etypingScore: computed((): number =>
        Math.round(state.tpm * Math.pow(state.rate, 3))
      ),
    });

    return {
      state,
    };
  },
});
